import {faCheck, faExclamation} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';

import useIsPasswordValid from '../util/isPasswordValid';

const PasswordState = ({password}) => {
	const {passwordState} = useIsPasswordValid(password);
	const specialChars = ' !"#$%&\\\'()*+,-./:;<=>?@[]^_`{|}~';
	return (
		<div className="mt-2">
			<div className="text-warning">
				<small>Must not reuse any of your past 4 passwords</small>
			</div>
			{passwordState.isLongEnough ? (
				<div className="text-success">
					<FontAwesomeIcon icon={faCheck} width={20} />
					<small>Must be at least 15 characters long (use of a passphrase is recommended)</small>
				</div>
			) : (
				<div className="text-danger">
					<FontAwesomeIcon icon={faExclamation} width={20} />
					<small>Must be at least 15 characters long (use of a passphrase is recommended)</small>
				</div>
			)}
			{passwordState.hasUpperCase ? (
				<div className="text-success">
					<FontAwesomeIcon icon={faCheck} width={20} />
					<small>Must have at least one uppercase letter</small>
				</div>
			) : (
				<div className="text-danger">
					<FontAwesomeIcon icon={faExclamation} width={20} />
					<small>Must have at least one uppercase letter</small>
				</div>
			)}
			{passwordState.hasLowerCase ? (
				<div className="text-success">
					<FontAwesomeIcon icon={faCheck} width={20} />
					<small>Must have at least one lowercase letter</small>
				</div>
			) : (
				<div className="text-danger">
					<FontAwesomeIcon icon={faExclamation} width={20} />
					<small>Must have at least one lowercase letter</small>
				</div>
			)}
			{passwordState.hasNumber ? (
				<div className="text-success">
					<FontAwesomeIcon icon={faCheck} width={20} />
					<small>Must have at least one number</small>
				</div>
			) : (
				<div className="text-danger">
					<FontAwesomeIcon icon={faExclamation} width={20} />
					<small>Must have at least one number</small>
				</div>
			)}
			{passwordState.hasSpecialCharacter ? (
				<div className="text-success">
					<FontAwesomeIcon icon={faCheck} width={20} />
					<small>Must have at least one special character </small>
					<code>{specialChars}</code>
				</div>
			) : (
				<div className="text-danger">
					<FontAwesomeIcon icon={faExclamation} width={20} />
					<small>Must have at least one special character </small>
					<code>{specialChars}</code>
				</div>
			)}
			{passwordState.doesNotHaveThreeOrMoreConsecutiveCharacters ? (
				<div className="text-success">
					<FontAwesomeIcon icon={faCheck} width={20} />
					<small>Must not have three or more consecutive characters</small>
				</div>
			) : (
				<div className="text-danger">
					<FontAwesomeIcon icon={faExclamation} width={20} />
					<small>Must not have three or more consecutive characters</small>
				</div>
			)}
		</div>
	);
};

PasswordState.propTypes = {
	password: PropTypes.string.isRequired
};

export default PasswordState;
